<div class="absolute z-1 mx-12 my-12 flex">
  <img class="horizontal-logo" [src]="'assets/layout/images/logo.svg'" width="200" alt="RGS+" />
</div>

<div
  class="flex min-h-screen items-center justify-center bg-cover bg-center px-8"
  [style]="{ 'background-image': 'url(assets/layout/images/pages/bg-404.png)' }"
>
  <div class="p-8">
    <div class="text-surface-900 p-text-secondary flex items-center justify-center pb-1 text-6xl font-bold">
      {{ 'general.selectEnvironment' | translate | uppercase }}
    </div>
    <div class="flex items-center justify-center pt-12">
      @if (licensesResource.isLoading()) {
        <div class="flex flex-col items-center justify-center">
          <p-progress-spinner [style]="{ width: '50px', height: '50px' }"></p-progress-spinner>
          <div class="text-surface-900 p-text-secondary pt-4 text-xl font-bold">
            {{ 'general.loadingLicenses' | translate }}
          </div>
        </div>
      } @else {
        @if (licensesResource.value().length > 0) {
          <p-listbox
            [options]="licensesResource.value()"
            optionLabel="label"
            optionValue="value"
            [style]="{ 'min-width': '25rem' }"
            [listStyle]="{ 'min-height': '27vh' }"
            [filter]="licensesResource.value().length > 10"
            (onClick)="licenseClicked($event)"
            [disabled]="loading()"
          ></p-listbox>
        } @else {
          <div class="flex items-center justify-center">
            <div class="text-surface-900 p-text-secondary pb-1 text-2xl font-bold">
              {{ 'general.noLicenses' | translate }}
            </div>
          </div>
        }
      }
    </div>
    <div class="flex items-center justify-center pt-4">
      @if (loading()) {
        <div class="flex items-center">
          <p-progress-spinner [style]="{ width: '20px', height: '20px' }" strokeWidth="4"></p-progress-spinner>
        </div>
      } @else {
        <a
          tabindex="0"
          (click)="logout()"
          (keydown.enter)="logout()"
          [style]="{
            color: 'var(--p-text-secondary)',
            'text-decoration': 'underline',
            cursor: 'pointer',
            'font-size': '1rem',
            'font-style': 'italic',
          }"
        >
          {{ 'buttons.logout' | translate }}?
        </a>
      }
    </div>
  </div>
</div>
